<mb-card-base
  class="column-card"
  [class.content-bottom]="alignContent === 'bottom'"
  [class.content-top]="alignContent === 'top'"
>
  <ng-container media>
    <ng-content select="[media]"></ng-content>
  </ng-container>

  <span *ngIf="data.icon" class="mb-icon {{ data.icon }}" icon></span>
  <div *ngIf="data.topline" class="topline copy-s font-family-text" topline [innerHTML]="data.topline"></div>
  <h2 *ngIf="data.headline" class="headline h4 font-family-title" headline [innerHTML]="data.headline"></h2>
  <div *ngIf="data.text" class="text copy-s" text [innerHTML]="data.text">}</div>
  <div
    *ngIf="fuelLabelPosition === 'default' && data.fuelLabel"
    class="fuel-label copy-s font-family-text"
    fuel-label
    [innerHTML]="data.fuelLabel"
  ></div>

  <ng-container *ngIf="data.translatableMetaItems?.length" meta-items>
    <ul class="meta-items">
      <li *ngFor="let item of data.translatableMetaItems" class="meta-item">{{ item.key | translate: item.data }}</li>
    </ul>
  </ng-container>
  <ng-container *ngIf="data.metaItems?.length" meta-items>
    <ul class="meta-items">
      <li *ngFor="let item of data.metaItems" class="meta-item">{{ item }}</li>
    </ul>
  </ng-container>

  <ng-container *ngIf="data.tags?.length" tags>
    <ul class="tag-items">
      <li *ngFor="let item of data.tags" class="tag-item mb-badge-small">{{ item }}</li>
    </ul>
  </ng-container>

  <ng-content action-container select="[action-container]"></ng-content>
</mb-card-base>

<div
  *ngIf="fuelLabelPosition === 'bottom' && data.fuelLabel"
  class="fuel-label copy-s font-family-text"
  [innerHTML]="data.fuelLabel"
  fuel-label-bottom
></div>
